

export const reorder = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};


const carrerasEIMC = ["1", "2", "4", "5", "6", "7"];

const carrerasEIMEA = ["3", "8"];

export const esMatematicasCiencias = ( pk_carrera ) => ( carrerasEIMC.includes(pk_carrera) ) ? true : false

export const esMatematicasEA = ( pk_carrera ) => ( carrerasEIMEA.includes(pk_carrera) ) ? true : false


export function buscar_cantidad_aspirantes( arreglo, nombre_completo = true ) {

    let aspirantes = []

    if ( nombre_completo ) {
        arreglo?.forEach( e => {
            if ( !aspirantes.includes( e.nombre ) ) {
                aspirantes.push( e.nombre )
            }
        });
    } else {
        arreglo?.forEach( e => {
            if ( !aspirantes.includes( e.prematricula ) ) {
                aspirantes.push( e.prematricula )
            }
        });
    }

    return ( aspirantes.length === 1 ) ? `${aspirantes?.length} aspirante` : `${aspirantes?.length} aspirantes`

}

